import { render, staticRenderFns } from "./EmojiPicker.vue?vue&type=template&id=60e237c8&scoped=true&"
import script from "./EmojiPicker.vue?vue&type=script&lang=ts&"
export * from "./EmojiPicker.vue?vue&type=script&lang=ts&"
import style0 from "./EmojiPicker.vue?vue&type=style&index=0&id=60e237c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e237c8",
  null
  
)

export default component.exports